import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface GuideSectionProps {
  id: string;
  title: string;
  description?: string;
  children: ReactNode;
  className?: string;
}

const GuideSection = ({ id, title, description, children, className }: GuideSectionProps) => {
  return (
    <section id={id} className={cn("scroll-mt-24", className)}>
      <div className="mb-6">
        <h2 className="mb-2 text-2xl font-semibold text-foreground">{title}</h2>
        {description && <p className="text-muted-foreground">{description}</p>}
      </div>
      <div className="space-y-6">{children}</div>
    </section>
  );
};

interface GuideSubSectionProps {
  id: string;
  title: string;
  description?: string;
  children: ReactNode;
  className?: string;
}

export const GuideSubSection = ({
  id,
  title,
  description,
  children,
  className,
}: GuideSubSectionProps) => {
  return (
    <div id={id} className={cn("scroll-mt-24", className)}>
      <h3 className="mb-2 text-xl font-medium text-foreground">{title}</h3>
      {description && <p className="mb-4 text-sm text-muted-foreground">{description}</p>}
      <div className="space-y-4">{children}</div>
    </div>
  );
};

export default GuideSection;
